module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-tab2-2",
      "name": "hres32e-tab2-tab2"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numoffid),
      expression: "detail.numoffid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:13'),
      expression: "'max:13'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numoffid",
      "name": "numoffid",
      "maxlength": "13",
      "data-vv-name": "numoffid",
      "has-error": _vm.errors.has('numoffid')
    },
    domProps: {
      "value": (_vm.detail.numoffid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numoffid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numoffid')),
      expression: "errors.has('numoffid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numoffid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteoffid",
      "has-error": _vm.errors.has('dteoffid')
    },
    model: {
      value: (_vm.detail.dteoffid),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteoffid", $$v)
      },
      expression: "detail.dteoffid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteoffid')),
      expression: "errors.has('dteoffid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteoffid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.adrissue),
      expression: "detail.adrissue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "adrissue",
      "name": "adrissue",
      "maxlength": "20",
      "data-vv-name": "adrissue",
      "has-error": _vm.errors.has('adrissue')
    },
    domProps: {
      "value": (_vm.detail.adrissue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "adrissue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('adrissue')),
      expression: "errors.has('adrissue')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('adrissue')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codprovr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codprovi),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codprovi", $$v)
      },
      expression: "detail.codprovi"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row data-row-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numpasid),
      expression: "detail.numpasid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numpasid",
      "name": "numpasid",
      "maxlength": "20",
      "data-vv-name": "numpasid",
      "has-error": _vm.errors.has('numpasid')
    },
    domProps: {
      "value": (_vm.detail.numpasid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numpasid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numpasid')),
      expression: "errors.has('numpasid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numpasid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:numpasid|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:numpasid|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtepasid",
      "has-error": _vm.errors.has('dtepasid')
    },
    model: {
      value: (_vm.detail.dtepasid),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtepasid", $$v)
      },
      expression: "detail.dtepasid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtepasid')),
      expression: "errors.has('dtepasid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtepasid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row data-row-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numprmid),
      expression: "detail.numprmid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numprmid",
      "name": "numprmid",
      "maxlength": "20",
      "data-vv-name": "numprmid",
      "has-error": _vm.errors.has('numprmid')
    },
    domProps: {
      "value": (_vm.detail.numprmid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numprmid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numprmid')),
      expression: "errors.has('numprmid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numprmid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:numprmid|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:numprmid|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteprmst",
      "has-error": _vm.errors.has('dteprmst')
    },
    model: {
      value: (_vm.detail.dteprmst),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteprmst", $$v)
      },
      expression: "detail.dteprmst"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteprmst')),
      expression: "errors.has('dteprmst')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteprmst')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:numprmid|date_format:DD/MM/YYYY|after:dteprmst'),
      expression: "'requiredWhenExist:numprmid|date_format:DD/MM/YYYY|after:dteprmst'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteprmen",
      "has-error": _vm.errors.has('dteprmen')
    },
    model: {
      value: (_vm.detail.dteprmen),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteprmen", $$v)
      },
      expression: "detail.dteprmen"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteprmen')),
      expression: "errors.has('dteprmen')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteprmen')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['120']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numlicid),
      expression: "detail.numlicid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:13'),
      expression: "'max:13'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numlicid",
      "name": "numlicid",
      "maxlength": "13",
      "data-vv-name": "numlicid",
      "has-error": _vm.errors.has('numlicid')
    },
    domProps: {
      "value": (_vm.detail.numlicid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numlicid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numlicid')),
      expression: "errors.has('numlicid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numlicid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:numlicid|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:numlicid|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtelicid",
      "has-error": _vm.errors.has('dtelicid')
    },
    model: {
      value: (_vm.detail.dtelicid),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtelicid", $$v)
      },
      expression: "detail.dtelicid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtelicid')),
      expression: "errors.has('dtelicid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtelicid')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic3
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['150']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic3),
      expression: "subTopic3"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.stamarry[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.stamarry),
      callback: function($$v) {
        _vm.$set(_vm.detail, "stamarry", $$v)
      },
      expression: "detail.stamarry"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC4']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.stamilit[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.stamilit),
      callback: function($$v) {
        _vm.$set(_vm.detail, "stamilit", $$v)
      },
      expression: "detail.stamilit"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d1e11a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab2_2.vue
// module id = 3840
// module chunks = 1